var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isInitializing)?_c('div',{staticClass:"init-spinner"},[_c('b-spinner',{attrs:{"large":""}})],1):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }